import {createStore} from '@web/helpers/redux'

import {MemberRootState} from '../../interfaces'

import Middlewares from './middlewares'
import createRootReducer from './reducer'
import FamilyMemberSentryEnhancer from './sentryEnhancer'

/** 맴버십 주문서 store */
const store = createStore<MemberRootState>({
    rootReducerCreator: createRootReducer,
    middlewares: Middlewares,
    sentryEnhancerOptions: FamilyMemberSentryEnhancer,
})

export default store
